export default __webpack_public_path__ + "static/media/ligh_bulb.ab40aaa6.png";